import { useFlags } from "launchdarkly-react-client-sdk";

import TopHeader from "components/common/TopHeader";

import "./Layout.css";
import "styles/Typography.scss";

function TimeoffLayout() {
  const { platformHeader } = useFlags();

  const subtext = "Manage time-off requests and view upcoming holidays here";

  if (platformHeader) {
    return (
      <div className="pb-20p">
        <TopHeader title="Time-off" subtext={subtext} />
      </div>
    );
  }

  return (
    <div className="layout-container">
      <div className="heading-h2-semibold color-text-neutral-20">Time-off</div>
      <div className="para-body-s-regular color-text-neutral-20">{subtext}</div>
    </div>
  );
}

export default TimeoffLayout;
